import React from 'react'
import { StyledOtpInput, OtpWrapper } from './styled'
import { PlainOtpProps } from './Otp.types'
import Flex from '../Flex'
import Text from '../Text'

const Otp: React.FC<PlainOtpProps> = ({
  error,
  value,
  onChange,
  digits = 6,
  isError = false,
  isInputNum = false,
  ...props
}) => {
  return (
    <OtpWrapper flexDirection='column' rowGap='16px' {...props}>
      <StyledOtpInput
        isError={isError}
        numInputs={digits}
        onChange={onChange}
        value={value}
        isInputNum={isInputNum}
        {...props}
      />
      {isError && (
        <Flex>
          <Text color='red50' variant='caption'>
            {error}
          </Text>
        </Flex>
      )}
    </OtpWrapper>
  )
}

export default Otp
